import React, { FunctionComponent } from 'react';
import { CircularProgress, Container } from '@mui/material';

const rootSx = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const Loader: FunctionComponent = () => {
  return (
    <Container sx={rootSx}>
      <CircularProgress />
    </Container>
  );
};

export default Loader;
